import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} • Volta Club </title>
                    <meta name="description" content="An electrifying establishment where digital currency meets discreet charm. Dive into decentralized finance and let sparks fly." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
